const SupportCasesEndpointFetchByPatientRequestHttpQueryParams = (request) => {
    return {
        patient_id: request.patient_id,
        page_size: request.pagination?.page_size,
        page_token: request.pagination?.page_token,
    };
};
export const SupportCasesEndpoint = (makeRequest) => {
    return {
        // Fetch Support Cases for a given patient
        fetchByPatient(params, options) {
            return makeRequest('GET', '/v2/support_cases/fetch_by_patient', SupportCasesEndpointFetchByPatientRequestHttpQueryParams(params), options);
        },
    };
};
//# sourceMappingURL=support_cases_endpoint.js.map